import React from "react";

 

const Header = () => (

  <div>

    <div>

      <a href="http://www.rotzler.de/" target="_blank">

        <img src="../images/rotzler_logo.png" alt="Logo" className="logo" />

      </a>

    </div>

    <h5 className="header-wrapper header-bg-color">

      ROTZLER TITAN product configurator

    </h5>

  </div>

);

 

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js